<div class="plume-source-marker">
    <div class="plume-source-marker__icon"></div>
    <div class="plume-source-marker__hint">
        {{ name }}
    </div>
</div>
